import React from 'react';

type PageHeroProps = {
  title: string;
  image?: string;
};

export const PageHero: React.FC<PageHeroProps> = ({ title, image }) => {
  return (
    <div className="PageHero">
      <div className={`PageHeroContent ${image ? 'WithImage' : ''}`}>
        <h1 className="HeroTitle">{title}</h1>
        {image && <img src={image} className="Image" alt="Hero" />}
      </div>
    </div>
  );
};
